import prism from "./prism";

export default {
  background: "#fafbfc",
  sideBackground: "#f0f2f5",
  accent: "#6366f1",
  articleText: "#374151",
  strongText: "#111827",
  border: "#e5e7eb",
  guideBackground: "#f0f9ff",

  gradient: "linear-gradient(135deg, rgba(99, 102, 241, 0.05) 0%, rgba(139, 92, 246, 0.08) 100%)",
  grey: "#6b7280",
  hover: "rgba(99, 102, 241, 0.08)",
  primary: "#6366f1",
  prism,
  secondary: "#10b981",
  track: "rgba(17, 24, 39, 0.2)",
  progress: "#6366f1",
  card: "#ffffff",
  error: "#ef4444",
  success: "#10b981",
  errorBackground: "rgba(239, 68, 68, 0.1)",
  horizontalRule: "rgba(17, 24, 39, 0.1)",
  inputBackground: "rgba(99, 102, 241, 0.05)",
  link: "#6366f1",
  modes: {
    dark: {
      background: "#0f172a",
      sideBackground: "#1e293b",
      accent: "#818cf8",
      articleText: "#cbd5e1",
      strongText: "#f1f5f9",
      border: "#334155",
      guideBackground: "#1e293b",

      grey: "#94a3b8",
      primary: "#a5b4fc",
      secondary: "#34d399",
      hover: "rgba(129, 140, 248, 0.15)",
      gradient:
        "linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(139, 92, 246, 0.1) 100%)",
      track: "rgba(241, 245, 249, 0.3)",
      progress: "#818cf8",
      card: "#1e293b",
      error: "#f87171",
      success: "#34d399",
      errorBackground: "rgba(248, 113, 113, 0.15)",
      horizontalRule: "rgba(241, 245, 249, 0.15)",
      inputBackground: "rgba(129, 140, 248, 0.1)",
      link: "#a5b4fc",
    },
  },
};
